import React from 'react';
import {connect} from 'react-redux';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('SIMPLE_DATE_SELECTOR', LOG_LEVELS.DEBUG);

export class SimpleDateSelector extends React.Component {

  dateChangeHandlerFactory(fieldName) {
    return (event) => {
      log.debug('dateChangeHandlerFactory(%s): %s, ', fieldName, event);
      log.debug('dateChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.props[fieldName], event.target.value);
      let selection = {};
      // TODO: Some date formatting to return the date in the right format.
      // TODO: Also some validation checking on the date.
      selection[fieldName] = event.target.value;
      this.props.selectionHandler(selection);
    }
  }


  render() {
    log.debug('render(): ', this.props);
    return (

      <input data-testid={this.props.dataTestID} type="date" onChange={this.dateChangeHandlerFactory(this.props.fieldName).bind(this)} value={this.props.value} {...this.props.extraProps} />

    )
  }
}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(SimpleDateSelector);